import React, { Component } from "react";

import Import from "./Import";

import _ from "lodash";

import List from "components/list/List";
import Pagination from "components/pagination/Pagination";
class ModelsMerch extends Component {
  componentDidMount() {
    this.props.init();
  }

  render() {
    const { modelsList, page, pages, pageSize, nbItems, getNext, modelsListLoading } = this.props;
    const columns = this.props.columns.map(column => {
      let newColumn = {
        title: column.title,
        dataIndex: column.key,
        key: column.key
      };
      if (column.sortable) {
        newColumn.onHeaderCell = () => {
          return {
            onClick: () => {
              const currentSortOrder = this.state.sortOrder;
              let nextSortOrder;
              if (currentSortOrder === 0) {
                nextSortOrder = -1;
              } else if (currentSortOrder === -1) {
                nextSortOrder = 1;
              } else {
                nextSortOrder = 0;
              }

              this.setState({ sortOrder: nextSortOrder }, () => {
                this.props.setSort(column.key, nextSortOrder);
              });
            }
          };
        };

        newColumn.sortOrder = null;
      }
      if (column.render) {
        newColumn.render = column.render;
      }
      return newColumn;
    });
    return (
      <div class="p-content-page-center p-content-page-center-full">
        <div class="p-content-page-center-header">
          <h2 class="p-content-page-center-header-title">Modèles MEA/PLV</h2>
        </div>
        <div class="p-content-page-center-content">
          <Import {...this.props} />
        </div>
        <div class="p-content-page-center-content">
          <List
            columns={columns}
            data={!_.isEmpty(modelsList) ? modelsList : []}
            page={page}
            pages={pages}
            defaultText="Aucun modèle trouvé."
            loading={modelsListLoading}
          />
          <div className="p-al-right p-mrg-ver">
            <Pagination page={page} pages={pages} pageSize={pageSize} nbItems={nbItems} getNext={getNext} />
          </div>
        </div>
      </div>
    );
  }
}

export default ModelsMerch;



// WEBPACK FOOTER //
// src/containers/admin/merch/List.js